import { useNavigate } from "react-router-dom";

export default function Footer(){

  const navigate = useNavigate();
  return (
    <footer className="mt-20 bg-black text-gray-300">
      <div className="container py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="text-2xl font-bold text-white mb-4">ONE<span className="text-primary">ZONE</span><span>TRAVELS</span></div>
          <div className="space-y-2 text-sm">About
         
            <div onClick={() => navigate('/about')} className="mt-2">About us</div>
            <div onClick={() => navigate('/contact')}>Contact</div>
          </div>
        </div>
        {/* <div>
          <div className="text-white font-semibold mb-4">Available Countries</div>
          <ul className="space-y-2 text-sm">
            <li>Australia</li>
            <li>Bangladesh</li>
            <li>Canada</li>
            <li>Denmark</li>
            <li>Finland</li>
            <li>England</li>
          </ul>
        </div> */}
        <div>
          <div className="text-white font-semibold mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li onClick={() => navigate('/about')}>About</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/tourpackage')}>Tour Packages</li>
            {/* <li onClick={() => navigate('/resources')}>Resources</li> */}
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-4">Policies</div>
          <ul className="space-y-2 text-sm">
            <li >Privacy</li>
            <li >Cookies</li>
            <li >Terms of use</li>
            <li >Terms & Conditions</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container py-6 text-xs text-gray-400">© {new Date().getFullYear()} ONEZONE. All rights reserved.</div>
      </div>
    </footer>
  );
}
